import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { eventTracker } from '_helpers';
import { useTimer } from '../../../../hooks/useTimer';
import events from '../../events';
import { cdnBaseUrl } from '../../../../app/apis';
import { Arrow, ArrowsContainer } from '../../../../styles/common-styles';

const BlogDetails = ({
  blogs,
  selectedBlogIndex,
  nextBlogHandler,
  previousBlogHandler,
  windowsWidth
}) => {
  // calculates how much time is spent
  useTimer(({ duration }) => eventTracker(
    events.BLOG_DETAILS_TIME_SPENT,
    { time_spent: duration, blog_id: blogs[selectedBlogIndex].blog_id }
  ));

  useEffect(() => {
    eventTracker(
      events.BLOG_DETAILS_LAND,
      { blog_item_id: blogs[selectedBlogIndex].blog_id }
    );
  }, [selectedBlogIndex]);
  return (
    <>
      <ImageContainer windowsWidth={windowsWidth}>
        <Image
          src={`${cdnBaseUrl}/blog_gallery/${blogs[selectedBlogIndex].image_path}`}
          alt="blog-galery"
          windowsWidth={windowsWidth}
        />
      </ImageContainer>
      <BlogDetailsBody
        key={selectedBlogIndex}
        dangerouslySetInnerHTML={{ __html: blogs[selectedBlogIndex].body }}
      />
      <ArrowsContainer>
        <Arrow
          disabled={selectedBlogIndex === 0}
          background="#269EE2"
          onClick={nextBlogHandler}
          aria-label="Next Blog"
        >
          &#8678;
        </Arrow>
        <Arrow
          disabled={selectedBlogIndex === blogs.length - 1}
          background="#269EE2"
          onClick={previousBlogHandler}
          aria-label="Previous Blog"
        >
          &#8680;
        </Arrow>
      </ArrowsContainer>
    </>
  );
};

export default BlogDetails;

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const BlogDetailsBody = styled.div`
  animation: ${OpacityAnimation} 0.5s;
  color: #404040 !important;
  padding: 0 15px;
  text-align: left !important;
  p, li {
    color: #404040;
    font-size: 16px !important;
    font-family: Roboto, sans-serif !important;
    text-align: left !important;
  }

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
    text-align: left !important;
  }
 
  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px 5px 15px;
  float: ${({ windowsWidth }) => windowsWidth > 650 && 'left'};
`;
const Image = styled.img`
  height: ${({ windowsWidth }) => (windowsWidth > 650 ? '350px' : '100%')};
  width: ${({ windowsWidth }) => (windowsWidth > 650 ? '350px' : '100%')};
  border-radius: 3px;
`;
